import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Alert from "../layout/Alert";
import PushNotification from "./pushNotification";
import UserSelection from "./userSelection";
import ScheduleNotification from "./scheduleNotification";
import { pushNotificationChannelTypes, notificationChannelTypes, notificationConstants, notificationDetailsRefreshRate, notificationStatusHeaders, showBroadcastCountryAlert, getCountryNameByCode } from './notificationConstant'
import EmailNotification from "./emailNotification";
import SMSNotification from "./smsNotification";
import { format } from "date-fns";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AdditionalInformation from "./additionalInformation";
import { selectMenuProps } from "../../utils/selectMenuProps";
import AppButton from "../Common/Button/Button";
import AppIconButton from "../Common/Button/IconButton";
import DataTable from "../Common/DataTable/DataTable";
import { useDesignTokens } from "../../theme/useDesignTokens";
import MuiDatePicker from "../Common/FormInputs/MuiDatePicker";
import FormInput from "../Common/FormInputs/MuiTextField";
import { SectionHeading, LabelText } from "../Common/Typography/AppTypography";
import { stripHtmlToPlainText } from "./notificationFormUtils";
const configFieldRowSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 280px)" },
  alignItems: "center",
  gap: { xs: 1, md: 1.5 },
  marginBottom: { xs: 1.5, md: 2 },
  width: "100%",
  "&:last-of-type": { marginBottom: 0 },
};
const notificationFieldControlSx = (theme) => ({
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  [theme.breakpoints.up("md")]: {
    maxWidth: 280,
  },
});
const sectionCardSx = {
  p: { xs: 1.5, md: 2 },
  mt: { xs: 1, md: 2 },
  boxShadow: 2,
  borderRadius: 1,
  overflow: "visible",
};

const tableHeaders = notificationStatusHeaders
const SendNotification = ({
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries,
    setAlert,
    notificationStore: { sendNotificationInProgress, sendNotificationSuccess, lastNotificationDetails },
    createNotificationTask,
    getNotificationTask,
    setDialog,
    setDialogContents,
    setDialogTab,
    userLevel
}) => {
    const theme = useTheme()
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const focusOutlineSx = {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid rgba(0, 0, 0, 0.42) !important",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: `${primaryColor} !important`,
        },
        "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline, & .Mui-expanded .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.42) !important",
            borderWidth: "1px",
        },
        "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.Mui-expanded": {
            color: `${primaryColor} !important`,
        },
    };
    const [channelType, setChannelType] = useState("")
    const [expiryDate, setExpiryDate] = useState(undefined)
    const [pnPlatforms, setPnPlatforms] = useState({
        iosPlatform: true,
        androidPlatform: true
    })
    const [severity, setSeverity] = useState("")
    const [fetchNotificationTimeout, setFetchNotificationTimeout] = useState(null);

    // push notification message
    const [pnMessage, setPnMessage] = useState("");
    const [emailNotificationData, setEmailNotificationData] = useState({ subject: "", html: "" })
    const [smsNotificationData, setSmsNotificationData] = useState("");
    const [copied, setCopied] = useState(false);

    //user selection criteria
    //const [countries, setCountries] = useState([])
    const [uploadedUserIdFileInput, setUploadedUserIdFileInput] = useState("")
    const userIdCSVFileInputRef = useRef()
    const [uploadedUserIdListFromCSV, setUploadedUserIdListFromCSV] = useState([])
    const [country, setCountry] = useState("None");
    const [deviceOwnership, setDeviceOwnership] = useState([])
    const [userStartLastLogin, setUserStartLastLogin] = useState(undefined)
    const [userEndLastLogin, setUserEndLastLogin] = useState(undefined)
    const [notificationTaskData, setNotificationTaskData] = useState(null)
    const [broadcastNotification, setBroadcastNotification] = useState(false)

    // schedule notifications
    const [scheduleNotification, setSheduleNotification] = useState(false)
    const [scheduleType, setScheduleType] = useState(notificationConstants.oneTimeScheduleType)
    const [multiScheduleDateTime, setMultiScheduleDateTime] = useState([])
    const [scheduleDayOfWeek, setScheduleDayOfWeek] = useState([])
    const [multiScheduleTime, setMultiScheduleTime] = useState([])

    //const [createNotificationTaskInProgress, setCreateNotificationTaskInProgress] = useState(false)

    // notification feedback
    const [feedbackRequired, setFeedbackRequired] = useState(false)

    // notification Tag
    const [notificationTag, setNotificationTag] = useState("")

    const menuProps = selectMenuProps;


    function onChangePushNotificationPlaformType(platformType, checkedStatus) {
        setPnPlatforms((prevState) => {
            return {
                ...prevState,
                [platformType]: checkedStatus
            }
        });
    }

    // push notification handler functions
    function onChangePushNotificationMessageData(messageData) {
        setPnMessage(messageData)
    }

    // user handler functions
    function onChangeUserCountry(userCountriesData) {
        setCountry(userCountriesData)
    }
    function onChangeUserDeviceOwnership(deviceOwnershipData) {
        setDeviceOwnership(deviceOwnershipData)
    }
    function onChangeUserStartLastLogin(userLastLoginData) {
        setUserStartLastLogin(userLastLoginData)
    }
    function onChangeUserEndLastLogin(userLastLoginData) {
        setUserEndLastLogin(userLastLoginData)
    }
    function onChangeUserIdListFileInput(fileData) {
        setUploadedUserIdListFromCSV([])
        setUploadedUserIdFileInput(fileData)
    }
    function onChangeBroadcastNotification(broadcast) {
        setBroadcastNotification(broadcast)
    }

    // scheduling functions
    function onChangeScheduleNotification(scheduleNotificationData) {
        setSheduleNotification(scheduleNotificationData)
    }
    function onChangeScheduleType(notificationScheduleType) {
        setScheduleType(notificationScheduleType)
    }
    function onChangeMultiScheduleDateTime(scheduleDateTimeData) {
        setMultiScheduleDateTime(scheduleDateTimeData)
    }
    function onChangeScheduleDayOfWeek(dayOfWeekData) {
        setScheduleDayOfWeek(dayOfWeekData)
    }
    function onChangeMultiScheduleTime(scheduleTimeData) {
        if (multiScheduleTime && multiScheduleTime.length===0) {
            setMultiScheduleTime([scheduleTimeData])
        }
        else {
            setMultiScheduleTime([...multiScheduleTime, scheduleTimeData])
        }
    }
    function onDeleteMultiScheduleTime(indextoDelete) {
        multiScheduleTime.splice(indextoDelete, 1)
        setMultiScheduleTime([...multiScheduleTime])

    }

    // Notification feedback
    function onChangeFeedbackRequired(feedback){
        setFeedbackRequired(feedback)
    }

    // Notification Tag
    function onChangeNotificationTag(notificationTag){
        setNotificationTag(notificationTag)
    }

    // general logic functions

    function parseUploadedUserIdFile() {
        return new Promise((resolve, reject) => {
            // parse uploaded file to get the list of product serial numbers
            const reader = new FileReader();
            reader.onload = function (event) {
                let textData = event.target.result

                let arrFileData = csvToArray(textData)
                if (arrFileData.length===0) {
                    setAlert("Empty File of User Ids Uploaded", "danger")
                    resolve([])
                }

                arrFileData = arrFileData.map((element) => {
                    return Object.values(element)[0].replace(/(\r\n|\n|\r)/gm, '')
                })
                //setUploadedUserIdListFromCSV(arrFileData)
                resolve(arrFileData)
            };

            reader.readAsText(uploadedUserIdFileInput);
        })

    }

    function csvToArray(str, delimiter = ",") {
        const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
        const rows = str.slice(str.indexOf("\n") + 1).split("\n");
        if (rows && rows.length > 0) {
            if (rows[rows.length - 1]==="") {
                rows.splice(-1) //removing the last element with empty values from array
            }
        }
        if (!rows || rows.length===0) {
            return []
        }
        const arr = rows.map(function (row) {
            const values = row.split(delimiter);
            const el = headers.reduce(function (object, header, index) {
                object[header] = values[index];
                return object;
            }, {});
            return el;
        });
        return arr;
    }

    const handleCreateNotificationTaskReset = useCallback(() => {
        setChannelType("");
        setExpiryDate(undefined);
        setSeverity("");
        setPnPlatforms({ iosPlatform: true, androidPlatform: true });
        setPnMessage("");
        setEmailNotificationData({ subject: "", html: "" });
        setSmsNotificationData("");
        setUploadedUserIdFileInput("");
        setUploadedUserIdListFromCSV([]);
        try {
            if (userIdCSVFileInputRef.current) userIdCSVFileInputRef.current.value = "";
        } catch (_) { /* noop */ }
        setCountry("None");
        setDeviceOwnership([]);
        setUserEndLastLogin(null);
        setUserStartLastLogin(null);
        setBroadcastNotification(false);
        setSheduleNotification(false);
        setScheduleType(notificationConstants.oneTimeScheduleType);
        setMultiScheduleDateTime([]);
        setScheduleDayOfWeek([]);
        setMultiScheduleTime([]);
        setFeedbackRequired(false);
        setNotificationTag("");
        window.scrollTo(0, 0);
    }, []);

    /** After successful task creation, mirror manual Reset behavior */
    useEffect(() => {
        if (!sendNotificationSuccess) return;
        handleCreateNotificationTaskReset();
    }, [sendNotificationSuccess, handleCreateNotificationTaskReset]);

    function handleCreateNotificationTask() {

        let notificationTaskRequest = {}

        //construct channel payload
        if (!channelType || channelType==="") {
            setAlert("Inavlid Channel Type. Please select a valid channel type", "danger")
            window.scrollTo(0, 0)
            return
        }
        notificationTaskRequest["channel"] = {}
        notificationTaskRequest["channel"]["type"] = channelType;
        if (channelType === notificationChannelTypes?.pushNotification?.value) {
            if (!pnMessage || pnMessage==="") {
                setAlert("Push notification message cannot be empty", "danger")
                window.scrollTo(0, 0)
                return
            }
            let msg = null;
            try {
                msg = JSON.parse(pnMessage)
            }
            catch (err) {
                setAlert("Push notification message should be valid JSON", "danger")
                window.scrollTo(0, 0)
                return
            }
            //construct the message payload - vary for each notification type
            notificationTaskRequest["message"] = {}
            notificationTaskRequest["message"]["payload"] = msg
            if (pnPlatforms['iosPlatform']===true) {
                if (!notificationTaskRequest["channel"].hasOwnProperty("platform")) {
                    notificationTaskRequest["channel"]["platform"] = []
                }
                notificationTaskRequest["channel"]["platform"].push('ios')
            }
            if (pnPlatforms['androidPlatform']===true) {
                if (!notificationTaskRequest["channel"].hasOwnProperty("platform")) {
                    notificationTaskRequest["channel"]["platform"] = []
                }
                notificationTaskRequest["channel"]["platform"].push('an')
            }

        }
        else if (channelType === notificationChannelTypes?.smsNotification?.value) {
            if (!smsNotificationData || smsNotificationData === "") {
                setAlert("SMS notification message cannot be empty", "danger")
                window.scrollTo(0, 0)
                return
            }
            notificationTaskRequest["message"] = {}
            notificationTaskRequest["message"]["text"] = smsNotificationData;
        }
        else if (channelType === notificationChannelTypes?.emailNotification?.value) {
            if (!emailNotificationData?.subject || emailNotificationData?.subject === "") {
                setAlert("Email notification subject cannot be empty", "danger")
                window.scrollTo(0, 0)
                return
            }
            else if (!stripHtmlToPlainText(emailNotificationData?.html)) {
                setAlert("Email notification requires text or html content.", "danger")
                window.scrollTo(0, 0)
                return
            }
            notificationTaskRequest["message"] = {}
            notificationTaskRequest["message"]["text"] = stripHtmlToPlainText(emailNotificationData?.html || "");
            notificationTaskRequest["message"]["html"] = emailNotificationData?.html;
            notificationTaskRequest["message"]["subject"] = emailNotificationData?.subject;
        }

        // check for severity
        if (!severity || severity.length==="") {
            setAlert("Inavlid Severity Type. Please Select Severity", "danger")
            window.scrollTo(0, 0)
            return
        }
        notificationTaskRequest["severity"] = severity


        //construct users payload
        if ((!uploadedUserIdFileInput || uploadedUserIdFileInput==="") && (!country || country.length===0) && (!deviceOwnership || deviceOwnership.length===0) &&
            (!userStartLastLogin) && (!userEndLastLogin)) {
            setAlert("Please Select Any of User Ids, Country, Device Ownership, Start or End Login Date", "danger")
            window.scrollTo(0, 0)
            return
        }
        notificationTaskRequest["users"] = {}
        if (broadcastNotification && country && country!=="") {
            notificationTaskRequest["users"]["broadcast"] = broadcastNotification
            if(country !== "None"){
                notificationTaskRequest["users"]["country"] = country?.toLowerCase()
            }
            
            const confirmed = showBroadcastCountryAlert(getCountryNameByCode(country))
            if (!confirmed) {
              handleCreateNotificationTaskReset();
              return;
            }
        }
        if (deviceOwnership && deviceOwnership.length > 0) {
            notificationTaskRequest["users"]["categories"] = [...deviceOwnership]
        }
        if (userStartLastLogin) {
            if (!notificationTaskRequest["users"].hasOwnProperty("lastLogin")) {
                notificationTaskRequest["users"]["lastLogin"] = {}
            }
            notificationTaskRequest["users"]["lastLogin"]["gt"] = userStartLastLogin
        }
        if (userEndLastLogin) {
            if (!notificationTaskRequest["users"].hasOwnProperty("lastLogin")) {
                notificationTaskRequest["users"]["lastLogin"] = {}
            }
            notificationTaskRequest["users"]["lastLogin"]["lt"] = userEndLastLogin
        }

        //construct schedule payload
        if (scheduleNotification) {
            if (!scheduleType) {
                setAlert("Please Select Schedule Notification Type", "danger")
                window.scrollTo(0, 0)
                return
            }
            notificationTaskRequest["schedule"] = {}
            if (scheduleType===notificationConstants.oneTimeScheduleType) {
                if (!multiScheduleDateTime || multiScheduleDateTime.length===0) {
                    setAlert("Please Select Scheduling Date & Time", "danger")
                    window.scrollTo(0, 0)
                    return
                }
                notificationTaskRequest["schedule"]["time"] = new Date(multiScheduleDateTime[0]).getTime()
            }
            else if (scheduleType===notificationConstants.repeatScheduleType) {
                if (!multiScheduleTime || multiScheduleTime.length===0) {
                    setAlert("Please Select Scheduling Time", "danger")
                    window.scrollTo(0, 0)
                    return
                }
                if (!scheduleDayOfWeek || scheduleDayOfWeek.length===0) {
                    setAlert("Please Select Scheduling Day of Week", "danger")
                    window.scrollTo(0, 0)
                    return
                }
                notificationTaskRequest["schedule"]["time"] = new Date(multiScheduleTime[0]).getTime()
                notificationTaskRequest["schedule"]["repeatType"] = scheduleDayOfWeek
            }
        }


        //construct expiry payload
        // expiry date is a mandatory parameter
        if (!expiryDate) {
            setAlert("Inavlid Expiry Type. Please select expiry time", "danger")
            window.scrollTo(0, 0)
            return
        }
        notificationTaskRequest["expiry"] = Math.round(expiryDate / 1000)

        // add notification feedback
        if(feedbackRequired){
            notificationTaskRequest["isFeedbackRequired"] = feedbackRequired
        }

        // add notification tag
        if(notificationTag.length > 0){
            notificationTaskRequest["notificationTag"] = notificationTag
        }


        // check if user file is uploaded
        if (uploadedUserIdFileInput && uploadedUserIdFileInput!=="") {
            if (!uploadedUserIdFileInput?.type?.includes("csv")) {
                setAlert("Please upload a csv file.", "danger")
                window.scrollTo(0, 0)
                return
            }
            parseUploadedUserIdFile()
                .then((arrUserIdsData) => {
                    notificationTaskRequest["users"]["userIds"] = arrUserIdsData
                    setNotificationTaskData({});
                    createNotificationTask(notificationTaskRequest)
                    window.scrollTo(0, 0)
                })
                .catch(() => {
                    setAlert("Failed to Parse User IDs Uploaded List", "danger")
                })
        }
        else {
            setNotificationTaskData({});
            createNotificationTask(notificationTaskRequest)
            window.scrollTo(0, 0)
        }
    }

    useEffect(() => {
        return () => {
            clearTimeout(fetchNotificationTimeout);
        }
    }, [])

    useEffect(() => {
        const expectedUserCount = lastNotificationDetails?.status?.taskProcessStatus?.userCount + lastNotificationDetails?.status?.taskProcessStatus?.userFailedCount
        const userSentCount = lastNotificationDetails?.status?.notificationProcessStatus?.userSentCount;
        const failedUserCount = lastNotificationDetails?.status?.notificationProcessStatus?.failedUserSentCount + lastNotificationDetails?.status?.notificationProcessStatus?.tokenNotFoundUserCount + lastNotificationDetails?.status?.taskProcessStatus?.userFailedCount
        if (lastNotificationDetails?.taskId) {
            clearTimeout(fetchNotificationTimeout);
            if (!(lastNotificationDetails?.status?.taskStatus === 'processed' && ((expectedUserCount === userSentCount) || (expectedUserCount === failedUserCount)))) {
                setFetchNotificationTimeout(setTimeout(() => {
                    getNotificationTask(lastNotificationDetails?.taskId, "updateSentNotification")
                }, notificationDetailsRefreshRate))
            }
        }
        setNotificationTaskData(JSON.stringify(lastNotificationDetails) !== "{}" ? {
            expectedUserCount: <div title="The expected number of users that will receive the  notification.">
                {
                    expectedUserCount
                }
            </div>,
            fullTaskId: lastNotificationDetails?.taskId,
            taskId: <div>
                <div title={lastNotificationDetails?.taskId}>
                    {
                        "..." + lastNotificationDetails?.taskId?.substring(lastNotificationDetails?.taskId?.length - 6, lastNotificationDetails?.taskId?.length)
                    }
                </div>
            </div>,
            userCount: <div title={"The number of users that received the notification."}>
                {
                    userSentCount
                }
            </div>,
            taskStatus: lastNotificationDetails?.status?.taskStatus,
            failureCount: <div title={"The number of users the notification failed to reach."}>
                {
                    failedUserCount
                }
            </div>,
            notificationType: notificationChannelTypes[lastNotificationDetails?.channel?.type + "Notification"]?.label,
            severity: lastNotificationDetails?.severity,
            createdAt: format(new Date(lastNotificationDetails?.creationDate * 1000), "dd MMM yyyy 'AT' hh:mm a"),
            expiryDate: format(new Date(lastNotificationDetails?.expiry * 1000), "dd MMM yyyy 'AT' hh:mm a"),
            payload: { ...lastNotificationDetails },
            msg: lastNotificationDetails?.message?.payload,
            action: (data) => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <AppIconButton
                    variant="primary"
                    size="small"
                    icon={<VisibilityIcon fontSize="small" />}
                    tooltip="View notification"
                    onClick={() => {
                      setDialog(true);
                      setDialogTab(0);
                      setDialogContents({ content: "notificationDetails", title: "Notification Details", data })
                    }}
                  />
                </Box>
            )
        } : {})
    }, [lastNotificationDetails])

    return (
        <Fragment>
            <Alert />
            <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", pb: 2 }}>
            {notificationTaskData && JSON.stringify(notificationTaskData) !== "{}" && (
              <Paper sx={{ ...sectionCardSx, mt: 1 }}>
                <SectionHeading sx={{ mb: 1 }}>
                  Last Sent Notification details
                </SectionHeading>
                <DataTable
                  columns={Object.keys(tableHeaders).map((key) => ({
                    key,
                    label: tableHeaders[key]?.label,
                    align: tableHeaders[key]?.align,
                    width: tableHeaders[key]?.width,
                    minWidth: tableHeaders[key]?.minWidth,
                    justifyContent: tableHeaders[key]?.style?.justifyContent,
                    render: (val, row) => {
                      const value =
                        row?.hasOwnProperty(key)
                          ? typeof row[key] === "function"
                            ? row[key](row)
                            : row[key]
                          : "-";
                      const isLong = String(value).length > 200;
                      if (key === "taskId") {
                        return (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <span
                              style={{
                                whiteSpace: isLong ? "normal" : "nowrap",
                                wordBreak: isLong ? "break-word" : "normal",
                              }}
                            >
                              {value}
                            </span>
                            <AppIconButton
                              size="small"
                              variant="ghost"
                              tooltip="Copy Task ID"
                              onClick={() => {
                                setCopied(true);
                                setTimeout(() => {
                                  setCopied(false);
                                }, 3000);
                                navigator?.clipboard?.writeText(row?.fullTaskId);
                              }}
                              icon={copied ? <CheckCircleOutlineIcon /> : <FileCopyIcon />}
                            />
                          </Box>
                        );
                      }
                      return (
                        <span
                          style={{
                            whiteSpace: isLong ? "normal" : "nowrap",
                            wordBreak: isLong ? "break-word" : "normal",
                          }}
                        >
                          {value}
                        </span>
                      );
                    },
                  }))}
                  data={[notificationTaskData]}
                  rowKey="taskId"
                  maxHeight="360px"
                  minWidth="100%"
                />
              </Paper>
            )}
            <Paper sx={sectionCardSx}>
                <Box sx={{ display: "grid", gap: 2 }}>
                    <Box sx={configFieldRowSx}>
                        <LabelText sx={{ fontWeight: 400 }}>Channel:</LabelText>
                        <Box sx={notificationFieldControlSx(theme)}>
                            <FormInput
                              type="select"
                              size="small"
                              fullWidth
                              name="channelType"
                              value={channelType}
                              onChange={(e) => setChannelType(e.target.value)}
                              options={Object.keys(pushNotificationChannelTypes).map((key) => ({
                                value: notificationChannelTypes[key]?.value,
                                label: notificationChannelTypes[key]?.label,
                              }))}
                              displayEmpty
                              renderValue={(v) =>
                                !v ? "Select Channel" : notificationChannelTypes[Object.keys(notificationChannelTypes).find(k => notificationChannelTypes[k]?.value === v)]?.label || v
                              }
                              MenuProps={menuProps}
                              sx={focusOutlineSx}
                            />
                        </Box>
                    </Box>
                    <Box sx={configFieldRowSx}>
                        <LabelText sx={{ fontWeight: 400 }}>Expiry:</LabelText>
                        <Box sx={{ ...notificationFieldControlSx(theme), ...focusOutlineSx }}>
                            <MuiDatePicker
                              label="Expiry Date"
                              value={expiryDate ? new Date(expiryDate) : null}
                              minDate={new Date()}
                              onChange={(date) => setExpiryDate(date ? date.getTime() : null)}
                            />
                        </Box>
                    </Box>
                    <Box sx={configFieldRowSx}>
                        <LabelText sx={{ fontWeight: 400 }}>Severity:</LabelText>
                        <Box sx={notificationFieldControlSx(theme)}>
                            <FormInput
                              type="select"
                              size="small"
                              fullWidth
                              name="severity"
                              value={severity}
                              onChange={(e) => setSeverity(e.target.value)}
                              options={[
                                { value: notificationConstants.notifySeverityInfo, label: "Info" },
                                { value: notificationConstants.notifySeverityAlert, label: "Alert" },
                                { value: notificationConstants.notifySeverityRecommendation, label: "Recommendation" },
                                { value: notificationConstants.notifySeverityPromotion, label: "Promotion" },
                              ]}
                              displayEmpty
                              renderValue={(v) => {
                                if (!v) return "Select Severity";
                                const match = [
                                  { value: notificationConstants.notifySeverityInfo, label: "Info" },
                                  { value: notificationConstants.notifySeverityAlert, label: "Alert" },
                                  { value: notificationConstants.notifySeverityRecommendation, label: "Recommendation" },
                                  { value: notificationConstants.notifySeverityPromotion, label: "Promotion" },
                                ].find(o => o.value === v);
                                return match?.label || v;
                              }}
                              MenuProps={menuProps}
                              sx={focusOutlineSx}
                            />
                        </Box>
                    </Box>
                </Box>
            </Paper>
            {channelType !== "" && (
                channelType === notificationChannelTypes?.emailNotification?.value ? (
                    <EmailNotification
                        handleMessageData={(name, value) => { setEmailNotificationData({ ...emailNotificationData, [name]: value }) }}
                        messageData={emailNotificationData}
                    />
                ) : channelType === notificationChannelTypes?.pushNotification?.value ? (
                    <PushNotification
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        setAlert={setAlert}
                        pnMessage={pnMessage}
                        handleMessageData={onChangePushNotificationMessageData}
                        pnPlatforms={pnPlatforms}
                        handlePlatformChange={onChangePushNotificationPlaformType}
                    />
                ) : (
                    <SMSNotification messageData={smsNotificationData} handleMessageData={setSmsNotificationData} />
                )
            )}
            <UserSelection
                allowedDeviceCategories={allowedDeviceCategories}
                allowedCompanyBrand={allowedCompanyBrand}
                allowedCountries={allowedCountries}
                setAlert={setAlert}
                uploadedUserIdFileInput={uploadedUserIdFileInput}
                handleUserIdFileInput={onChangeUserIdListFileInput}
                userIdCSVFileInputRef={userIdCSVFileInputRef}
                country={country}
                handleUserCountries={onChangeUserCountry}
                deviceOwnership={deviceOwnership}
                handleUserDeviceOwnership={onChangeUserDeviceOwnership}
                userStartLastLogin={userStartLastLogin}
                userEndLastLogin={userEndLastLogin}
                handleUserStartLastLogin={onChangeUserStartLastLogin}
                handleUserEndLastLogin={onChangeUserEndLastLogin}
                userLevel={userLevel}
                broadcastNotification={broadcastNotification}
                handleBroadcastNotification={onChangeBroadcastNotification}
            ></UserSelection>
            {/* Will implement schedule notification later on */}
            {/* <ScheduleNotification
                setAlert={setAlert}
                scheduleNotification={scheduleNotification}
                handleScheduleNotification={onChangeScheduleNotification}
                scheduleType={scheduleType}
                handleScheduleTypeChange={onChangeScheduleType}
                multiScheduleDateTime={multiScheduleDateTime}
                handleMultiScheduleDateTime={onChangeMultiScheduleDateTime}
                scheduleDayOfWeek={scheduleDayOfWeek}
                handleScheduleDayOfWeekChange={onChangeScheduleDayOfWeek}
                multiScheduleTime={multiScheduleTime}
                handleMultiScheduleTimeChange={onChangeMultiScheduleTime}
                handleDeleteMultiScheduleTime={onDeleteMultiScheduleTime}
            ></ScheduleNotification> */}
            <AdditionalInformation
                feedbackRequired={feedbackRequired}
                handleFeedbackRequired={onChangeFeedbackRequired}
                notificationTag={notificationTag}
                handleNotificationTag={onChangeNotificationTag}
            >
            </AdditionalInformation>
            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mt: 2, pb: 1 }}>
                <AppButton
                    variant="primary"
                    size="medium"
                    onClick={handleCreateNotificationTask}
                    disabled={sendNotificationInProgress}
                    loading={sendNotificationInProgress}
                >
                    Create Notification Task
                </AppButton>
                <AppButton
                    variant="ghost"
                    size="medium"
                    onClick={handleCreateNotificationTaskReset}
                    disabled={sendNotificationInProgress}
                >
                    Reset
                </AppButton>
            </Box>
            </Box>
        </Fragment>
    );
}

export default SendNotification